module.exports = __webpack_public_path__ + "media/images/brand/app_logo_white_text-f7eeddb0944a34b8ff57799b6f53d5de.png";